import { Params } from '@angular/router';

import { isNullOrUndefined } from '@app/util/util';
import { HotelSearched } from '@hotels/hotel-results/entities/hotel-searched';
import { currencyFormat } from '@hotels/hotel-results/helpers/hotels.helpers';
import { HotelSearchResponse } from '@hotels/hotel-results/entities/hotel-search.response';
import { HotelResultsState } from '@hotels/hotel-results/store/reducers/hotel-results.reducer';
import { HotelSearchResultsData } from '@hotels/hotel-results/entities/hotel-search-results-data';
import { HotelSearchPayload } from '@hotels/hotel-results/entities/hotel-search.payload';
import { HotelMarker } from '@hotels/hotel-results/entities/hotel-marker';
import { HotelDateValidator } from '@hotels/hotel-results/entities/date-validator';
import { mapPayloadHotelRooms } from '@ux/mappers/guest.mapper';
import { HotelDestinationInputType } from '@shared/base-search-bar/entities/autocomplete-destionation';
import { getBaseRequestSettings } from '@app/mappers/reguest-settings.mapper';
import { packHours } from '@shared/magic-filter-bar/byhours-filter-hour/constants/byhours.constant';

const addStartDate = 15;
const addEndDate = 20;

type Payload = Readonly<{
  destination_id: string;
  destination_type: string;
  check_in: string;
  check_out: string;
  currency_code: string;
  rooms: string;
}>;

export function mapPayloadHotel(payload: Params, isMobile: boolean, from: string = null): HotelSearchPayload {
  return {
    CheckIn: payload.check_in,
    CheckOut: payload.check_out,
    Rooms: mapPayloadHotelRooms(payload.rooms),
    MaxResults: 0,
    IncludeHotelInfo: true,
    CurrencyCode: payload.currency_code,
    RequestSettings: getBaseRequestSettings(isMobile),
    IncludeRooms: false,
    DestinationType: payload.destination_type as HotelDestinationInputType,
    LocationId: Number(payload.destination_id),
  };
}


export function mapPayloadHotelByHours(payload: Params, isMobile: boolean): HotelSearchPayload {
  return {
    CheckIn: payload.check_in,
    MaxResults: 0,
    PackHours: packHours,
    IncludeHotelInfo: true,
    CurrencyCode: payload.currency_code,
    RequestSettings: getBaseRequestSettings(isMobile),
    IncludeRooms: false,
    DestinationType: payload.destination_type as HotelDestinationInputType,
    LocationId: Number(payload.destination_id),
  };
}

export function mapSearchHotelPayload(payload: HotelSearchPayload, token: string): HotelSearchPayload {
  return {
    ...payload,
    SessionToken: token
  };
}

export function mapSearchHotelResultsPaginate
(state: HotelResultsState, hotels: HotelSearched[]): HotelSearchResponse {
  if (hotels) {
    const defaultState = {
      ...state,
      Results: state.Results.concat(hotels),
      ResultsMarkers: state.Results.concat(hotels),
    };
    const searchedHotel = getSearchedHotel(hotels);
    if (searchedHotel) {
      return {
        ...state,
        Results: state.Results.concat(hotels),
        ResultsMarkers: state.Results.concat(hotels),
        SearchedHotel: searchedHotel
      };
    } else return defaultState;

  } else return state;
}

export function mapSearchHotelEclusiveOffer
(state: HotelResultsState, hotels: HotelSearched[]): HotelSearchResponse {
  return {
    ...state,
    ResultsExclusiveOffer: hotels,
  };
}

export function mapSearchHotelMarkers
(state: HotelResultsState, hotels: HotelSearched[]): HotelSearchResponse {
  if (hotels) {
    const defaultState = {
      ...state,
      ResultsMarkers: hotels,
    };
    const searchedHotel = getSearchedHotel(hotels);
    if (searchedHotel) {
      return {
        ...state,
        ResultsMarkers: hotels,
        SearchedHotel: searchedHotel
      };
    } else return defaultState;
  } else return state;
}

export function mapHotelMarkers(hotels: HotelSearched[]): HotelMarker[] {
  return !isNullOrUndefined(hotels) ? hotels.map((hotel: HotelSearched) => {
    return {
      hotel,
      position: { lat: hotel.Latitude, lng: hotel.Longitude },
      label: currencyFormat(hotel.PriceFrom)
    };
  }) : hotels as HotelMarker[];
}

export function mapHotelSearchData(state: HotelResultsState): HotelSearchResultsData {
  const { ResultsAvailableUntil, SearchId, ResultsCount, session } = state;
  return { ResultsAvailableUntil, SearchId, ResultsCount, session };
}

export function dateHotelValidation(departure: Date, arrival: Date): HotelDateValidator {
  const currentDateArrival = new Date();
  const currentDateDeparture = new Date();

  currentDateArrival.setHours(0, 0, 0, 0);
  currentDateDeparture.setHours(0, 0, 0, 0);
  departure.setHours(0, 0, 0, 0);
  arrival.setHours(0, 0, 0, 0);

  if (arrival < currentDateArrival || departure < currentDateDeparture) {
    currentDateDeparture.setDate(currentDateDeparture.getDate() + addStartDate);
    currentDateArrival.setDate(currentDateArrival.getDate() + addEndDate);
    return {
      arrival: currentDateArrival,
      departure: currentDateDeparture,
      valid: false
    };
  } else return { arrival, departure, valid: true };
}

export function formatDate(date: Date): string {
  let month = `${(date.getMonth() + 1)}`,
    day = `${date.getDate()}`;
  const year = date.getFullYear();
  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;
  return [year, month, day].join('-');
}

function getSearchedHotel(hotels: HotelSearched[]): HotelSearched {
  return hotels.find(hotel => !!hotel.IsSearchedhotel && !hotel.IsSearchedhotelOrder);
}
